import { useAppSelector } from "@/core/root-reducer"
import PreventionActionsChecklist from "@/entities/prevention-action/ui/PreventionActionsChecklist"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import preventionActionStore from "@/entities/prevention-action/model/prevention-action.store"

export default function PhysicalRiskPreventionStep({ onAdd }: { onAdd: () => void }) {
  const draftRisk = useAppSelector(physicalRiskStore.selectors.draft)
  const preventionActions = useAppSelector((state) => preventionActionStore.selectors.listForRisk(state, draftRisk.id))

  //Pas de titre : l'etape est nommee par la sidebar du wizard et par la question de la chouette.
  //L'ajout d'une mesure est porte par le pied de la modale, a cote du bouton principal.
  return (
    <div className="mt-20">
      {/* Pas de reevaluation ici : le "Continuer" du wizard la declenche a la sortie de l'etape */}
      <PreventionActionsChecklist preventionActions={preventionActions} onAdd={onAdd} />
    </div>
  )
}
